import Crud from './crud'
var crud = new Crud('product_types', 'loại hàng');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Name: '',
        IsHidden: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};